/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { REFRESH_TOKEN_INTERVAL_MILLISECONDS } from '../../../constants/main';
import { decodeJWT } from '../decodeJWT';

/**
 * Sees whether a JWT is about to expire
 *
 * @param {String} token The token string to parse.
 * @returns {Boolean} Whether the token is about to expire
 */
export const isTokenAboutToExpire = (token) => {
  const tokenExpiration = decodeJWT(token).exp * 1000;
  const willExpire = tokenExpiration - Date.now() <= REFRESH_TOKEN_INTERVAL_MILLISECONDS;
  return willExpire;
};
